export default{
    years: [
    {
        id: 2015,
        title: 'XII',
        backgroundImg: 'https://source.unsplash.com/A3FNnZ55bR8/704X468',
        memories: [
            "ISC!!",
            "Weekend labs",
            "College admissions"
        ],
    },
    {
        id: 2013,
        title: 'X',
        backgroundImg: 'https://source.unsplash.com/A3FNnZ55bR8/640X426',
        memories: [
            "ICSE!!",
            "Saraswati Puja",
            "School admissions"
        ],
    },
]
} 


// WEBPACK FOOTER //
// ./src/data/years.js